import Skeleton from "@mui/material/Skeleton";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

import ageCalculator from "@/utils/agecalculator";
import phoneFormatter from "@/utils/pfoneFormatter";
import { setIsVisibleModalDialog } from "@/store/ui/ui";
import { setPatientId, setPatientsBirthDay } from "@/store/patients/patients";
import useGetRole from "@/hooks/useGetRole";
import { adminMessage } from "@/utils/constants";
import { toast } from "react-toastify";

import { PatientsListProps } from "@/shared/interfaces/patientPage";

import "./PatientsList.scss";
import { dateFormatter } from "@/utils/dateFormatter";

export default function PatientsList({ data, isLoading }: PatientsListProps) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isAdmin } = useGetRole();

    const handleDelete = (id: string) => {
        if (isAdmin) {
            dispatch(setPatientId(id));
            dispatch(setIsVisibleModalDialog(true));
        } else toast.error(adminMessage);
    };

    return (
        <section className='appoints_main_content patients_listing_container'>
            <table className='listing_table'>
                <thead>
                    <tr>
                        <th>ПІБ пацієнта</th>
                        <th>Телефон</th>
                        <th>Вік</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading
                        ? Array.from({ length: 14 }).map((_, index) => (
                              <tr key={index}>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              maxWidth: "93%",
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          height={34}
                                          style={{
                                              padding: 8,
                                              maxWidth: "74%",
                                              margin: "auto",
                                          }}
                                      />
                                  </td>
                                  <td>
                                      <Skeleton
                                          variant='text'
                                          width={"100%"}
                                          height={34}
                                          style={{ padding: 8 }}
                                      />
                                  </td>
                              </tr>
                          ))
                        : data &&
                          data.map(patient => (
                              <tr key={patient._id}>
                                  <td
                                      className='listing_table_patients_name'
                                      id={patient._id}
                                      onClick={() => {
                                          navigate(`/patients/${patient._id}`);
                                          dispatch(
                                              setPatientsBirthDay(
                                                  dateFormatter(
                                                      patient.dateOfBirth
                                                          ? new Date(
                                                                patient.dateOfBirth,
                                                            )
                                                          : new Date(),
                                                  ),
                                              ),
                                          );
                                      }}
                                  >
                                      {patient.name}
                                  </td>
                                  <td id='patients_item'>
                                      {patient && patient.primaryPhone
                                          ? phoneFormatter(patient.primaryPhone)
                                          : ""}
                                  </td>
                                  <td id='patients_item'>
                                      {patient && patient.dateOfBirth
                                          ? ageCalculator(patient.dateOfBirth)
                                          : ""}
                                  </td>
                                  <td>
                                      <button
                                          className='listing_icons'
                                          id={patient._id}
                                          onClick={e =>
                                              handleDelete(e.currentTarget.id)
                                          }
                                      >
                                          <img
                                              src='/patients/delete.svg'
                                              alt='edit-logo'
                                              id={patient._id}
                                          />
                                      </button>
                                  </td>
                              </tr>
                          ))}
                </tbody>
            </table>
        </section>
    );
}
